import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

export default new vuex.Store({
    state: {
        show: false,
        wb: null,
        rABS: null,
        keys: [],
        SheetBox: [],
        isShow: false,
        proMsg: [],
        pageNo:1
    },
    mutations: {
        changeWb(state, wb) {
            state.wb = wb
        },
        changeRABS(state, rABS) {
            state.rABS = rABS
        },
        changeSheetBox(state, box) {
            state.SheetBox = box
        },
        changeIsShow(state, show) {
            state.isShow = show
        },
        changeKeys(state, keys) {
            state.keys = keys
        },
        changePromsg(state, msg) {
            state.proMsg = msg
        },
        changePageNo(state,pageNo){
            state.pageNo = pageNo
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js